import { ref, computed } from 'vue';
import { useComponentI18n } from '@rdrive/i18n';
import messages from './messages/index.js';

export default (props, { emit }) => {
  // LOCAL composer with the warn flags off — see @rdrive/i18n for why the flags are
  // assigned rather than passed.
  const { t } = useComponentI18n(messages);

  const dialog = computed({
    get: () => props.modelValue,
    set: (value) => emit('update:modelValue', value)
  });

  // Key to force re-render of buttons when bulk operations happen. The template keys the
  // statuses row `statuses-<n>`, a STRING: as a bare number it could equal the compiler's numeric
  // key on the "No Available Status" v-else branch, and Vue then patched one into the other in
  // place — the text kept the row's classes after a toggle-all that hid every status (IA step 13.2).
  const filterKey = ref(0);

  const handleToggleAll = () => {
    filterKey.value++;
    emit('toggleAll');
  };

  const buttonColor = computed(() => props.theme === 'dark' ? 'grey-lighten-5' : 'grey-darken-3');

  return {
    // `emit` is a template binding here: the status/type buttons call
    // `emit('toggleStatus', …)` / `emit('toggleType', …)` inline, exactly as they
    // did when this was a script-setup SFC.
    emit,
    t,
    dialog,
    filterKey,
    handleToggleAll,
    buttonColor,
  };
};
